import plantImages from '../assets/plants/plant_images.json';

const normalize = (name) => name?.toLowerCase().replace(/\s+/g, '_').replace(/[^a-z0-9_]/g, '');

const loadDynamicImage = (imageName) => {
  if (!imageName || imageName.length <= 2) return null;
  const normalized = normalize(imageName);
  const found = plantImages.find(img => normalize(img.name) === normalized);
  return found ? found.image_url : null;
};

export default loadDynamicImage;
